import Changelog from '@mozaic-ds/gatsby-theme-styleguide/src/gatsby-components/Changelog';
import * as React from 'react';
export default {
  Changelog,
  React
};